const outputs = ['B', 'KB', 'MB', 'GB', 'TB', 'PB']
export const fileSizeTransform = (bytes) => {
  const log = Math.floor(Math.log10(bytes))
  const range = Math.floor((1 + log) / 3)
  const num = Math.round((100 * bytes) / Math.pow(10, log)) / 100
  const value = Math.round((100 * num) / Math.pow(10, 3 * range - log)) / 100
  return (value + ' ' + outputs[range]).replace('.', ',')
}
